import React, { FC } from 'react';
import { Box, BoxProps, defaultColors } from '@lifechurch/react-ion';

type TableProps = {
  testId?: string;
  styles?: BoxProps;
};

const TableBody: FC<TableProps> = ({ testId, styles, children }) => (
  <Box
    backgroundColor='white'
    borderRadius={2}
    boxShadow={1}
    py={2}
    data-testid={testId}
    {...styles}
  >
    {children}
  </Box>
);

export const BorderedTableBody: FC<TableProps> = ({ testId, styles, children }) => (
  <TableBody
    testId={testId}
    styles={{ boxShadow: 0, border: `1px solid ${defaultColors.gray10}`, ...styles }}
  >
    {children}
  </TableBody>
);

export default TableBody;
